import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import InstagramIcon from '@mui/icons-material/Instagram';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDiscord } from '@fortawesome/free-brands-svg-icons'
import SitemarkIcon from './SitemarkIcon';
import { discordLink, instagramLink } from '../../Constants';

function Copyright() {
  return (
    <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
      {'Copyright © '}
      <Link color="text.secondary" href="https://tradespad.com/">
        TradesPad
      </Link>
      &nbsp;
      {new Date().getFullYear()}
    </Typography>
  );
}

export default function Footer() {
  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 4, sm: 8 },
        py: { xs: 4, sm: 8 },
        textAlign: { sm: 'center', md: 'left' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <div>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} paddingBottom="10px">
            <SitemarkIcon />
          </Typography>
          <Link color="text.secondary" variant="body2" href="/legal/privacy">
            Privacy Policy
          </Link>
          <Typography sx={{ display: 'inline', mx: 0.5, opacity: 0.5 }}>
            &nbsp;•&nbsp;
          </Typography>
          <Link color="text.secondary" variant="body2" href="/legal/terms">
            Terms of Service
          </Link>
          <Typography sx={{ display: 'inline', mx: 0.5, opacity: 0.5 }}>
            &nbsp;•&nbsp;
          </Typography>
          <Link color="text.secondary" variant="body2" href="https://help.tradespad.com" target="_blank">
            Help Center
          </Link>
          <Copyright />
          <Typography variant="body2" sx={{ color: 'text.secondary' }} paddingBottom="10px">
            Charts by <Link color="text.secondary" variant="body2" href="https://www.tradingview.com" target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'none', mt: 1, display: 'inline-block' }}>
              TradingView
            </Link>
          </Typography>
        </div>
        <Stack
          direction="row"
          spacing={1}
          useFlexGap
          sx={{ justifyContent: 'left', color: 'text.secondary' }}
        >
          <IconButton
            color="inherit"
            size="small"
            href={instagramLink}
            aria-label="Instagram"
            sx={{ alignSelf: 'center' }}
          >
            <InstagramIcon />
          </IconButton>
          <IconButton
            color="inherit"
            size="small"
            href={discordLink}
            aria-label="Instagram"
            sx={{ alignSelf: 'center' }}
          >
            <FontAwesomeIcon icon={faDiscord} />
          </IconButton>
        </Stack>
      </Box>
      <Box sx={{ width: '100%', mt: 4 }}>
        <Typography sx={{ color: 'text.secondary', opacity: 0.4, display: 'block', textAlign: 'justify', fontWeight: 600 }}>
          TradesPad is a journaling and performance analysis tool intended for educational and informational purposes only. The software does not provide financial advice,
          investment recommendations, or trading signals. Trading in financial markets involves substantial risk and may not be suitable for all investors. Past performance is
          not indicative of future results. Users are solely responsible for their trading decisions and capital management. TradesPad can only read and analyze data provided
          by the user or imported from supported platforms. It does not execute trades, place orders, or interact with brokers to perform transactions on behalf of the user.
        </Typography>
      </Box>
    </Container>
  );
}
